const getLocalState = state => state.pages.track || {}

export const getTitle = state => getLocalState(state).title
export const getVersion = state => getLocalState(state).version
export const isHiRes = state => getLocalState(state).hires
export const getAlbum = state => getLocalState(state).album || {}
export const getDuree = state => getLocalState(state).duration
export const getArtist = state => getLocalState(state).artist || {}
export const getOrderUrl = state => getLocalState(state).orderUrl
export const getPerformer = state => getLocalState(state).performer
export const getStreamableAt = state => getLocalState(state).release_date_stream
export const getComposer = state => getLocalState(state).composer || {}
export const getPerformers = state => getLocalState(state).performers
export const getMaximumBitDepth = state => getLocalState(state).maximum_bit_depth
export const getMaximumChannelCount = state => getLocalState(state).maximum_channel_count
export const getMaximumSamplingRate = state => getLocalState(state).maximum_sampling_rate



// WEBPACK FOOTER //
// ./src/pages/track/trackSelectors.js